// /////////////////////////////////////////////////////////////
// [ファイル] SalesProjectsTableProvider.tsx
// [概要] /salesprojectsmanagement 配下で useProjectTable の状態を共有するための Context。
//        親 Layout (SalesProjectsLayout) で一度だけ useProjectTable を呼び、
//        index ルート (一覧) と :id ルート (詳細) で同じ状態を参照する。
//        これにより 一覧 → 詳細 → 戻る のフローで、データ・page・検索条件・
//        並び順・適用中フィルタ名が保持される。
// /////////////////////////////////////////////////////////////
import { createContext, useContext } from 'react';
import type { MutableRefObject } from 'react';
import type { useProjectTable } from '../hooks/useProjectTable';

export type SalesProjectsTableContextValue = ReturnType<typeof useProjectTable> & {
  viewLevel: string;
  permissions: string[] | null;
  appliedFilterName: string | null;
  setAppliedFilterName: (name: string | null) => void;
  // 一覧テーブルのスクロール位置を Layout 側で保持する。
  // ページがアンマウントされても値が消えないよう ref で保持し、
  // 子ページ (一覧 / 詳細) の再マウント時に復元する。
  scrollPositionRef: MutableRefObject<number>;
};

export const SalesProjectsTableContext = createContext<SalesProjectsTableContextValue | null>(null);

export const useSalesProjectsTableContext = (): SalesProjectsTableContextValue => {
  const ctx = useContext(SalesProjectsTableContext);
  if (!ctx) {
    throw new Error('useSalesProjectsTableContext must be used within <SalesProjectsLayout>');
  }
  return ctx;
};
